import React from 'react'

const Sidebar = () => {
  const [isActive, setIsActive] = React.useState(false);
  const [isActiveshipment, setIsActiveshipment] = React.useState(false);
  const [isActiveintshipment, setIsActiveintshipment] = React.useState(false);

  const [isActivetools, setIsActivetools] = React.useState(false);
  const [isActivebilling, setIsActivebilling] = React.useState(false);
  const [isActivereport, setIsActivereport] = React.useState(false);
  const [isActivesupport, setIsActivesupport] = React.useState(false);
  const [isActivesetting, setIsActivesetting] = React.useState(false);






  // Toggle function
  const toggleActiveClass = () => {
    setIsActive(!isActive);
  };
  const toggleActiveClassshipment = () => {
    setIsActiveshipment(!isActiveshipment);
  };

  const toggleActiveintClassshipment = () => {
    setIsActiveintshipment(!isActiveintshipment);
  };
  
  const toggleActiveClasstools = () => {
    setIsActivetools(!isActivetools);
  };
  const toggleActiveClassbilling = () => {
    setIsActivebilling(!isActivebilling);
  };

  const toggleActiveClassreport = () => {
    setIsActivereport(!isActivereport);
  };

  const toggleActiveClasssupport = () => {
    setIsActivesupport(!isActivesupport);
  };
  const toggleActiveClasssetting = () => {
    setIsActivesetting(!isActivesetting);
  };
 
  const redirectToShipmentsPage = (statuses) => {
	const statusParam = statuses.join('%2C'); // Join status array with comma and encode
	window.location.href = `/shipments?status=${statusParam}&shipment=1`;
};
  const handleDeliveredShipmentsClick = () => {
	// Redirect to Shipments page with only status 5 included
	redirectToShipmentsPage([5]);
};
const handleBookedShipmentsClick = () => {
 
  redirectToShipmentsPage([1, 2, 3, 4, 5,6]);
};
const handleNdrShipmentsClick = () => {

redirectToShipmentsPage([8]);
};
const handleRtoShipmentsClick = () => {

redirectToShipmentsPage([10]);
};
const handleScheduledShipmentsClick = () => {

redirectToShipmentsPage([9]);
};




const redirectTointShipmentsPage = (statuses) => {
	const statusParam = statuses.join('%2C'); // Join status array with comma and encode
	window.location.href = `/shipments?status=${statusParam}&shipment=2`;
};
  const handleDeliveredintShipmentsClick = () => {
	// Redirect to Shipments page with only status 5 included
	redirectTointShipmentsPage([5]);
};
const handleBookedintShipmentsClick = () => {
 
	redirectTointShipmentsPage([1, 2, 3, 4, 5,6]);
};
const handleNdrintShipmentsClick = () => {

	redirectTointShipmentsPage([8]);
};
const handleRtointShipmentsClick = () => {

	redirectTointShipmentsPage([10]);
};
const handleScheduledintShipmentsClick = () => {

	redirectTointShipmentsPage([9]);
};
  return (
    <div>
      <div class="sidebarMenuScroll">
						<ul class="sidebar-menu">
						{/* <li class="treeview active">
								<a href="/create_order_1?value=0">
									<i class="bi bi-plus"></i>
									<span class="menu-text">Create Shipment</span>
								</a>
							</li> */}
							<li class="active current-page">
								<a href="/dashboard">
									<i class="bi bi-pie-chart"></i>
									<span class="menu-text">Dashboard</span>
								</a>
							</li>
							<li className={`treeview ${isActive ? 'active' : ''}`}>
								<a href="#"onClick={toggleActiveClass}>
									<i class="bi bi-bag"></i>
									<span class="menu-text">Orders</span>
								</a>
								<ul class="treeview-menu">
									<li>
										<a href="/orders">Domestic Orders</a>
									</li>
									<li ><a href="/international_orders" >International Orders</a></li>

									<li>
										<a href="/create_order_1?value=0">Create New Order</a>
									</li>
									<li>
										<a href="/bulk_order_upload">Import Bulk Orders</a>
									</li>
								</ul>
							</li>
							<li className={`treeview ${isActiveshipment ? 'active' : ''}`}>
								<a href="#!" onClick={toggleActiveClassshipment}>
									<i class="bi bi-box"></i>
									<span class="menu-text">Domestic Shipments</span>
								</a>
								<ul class="treeview-menu">
									<li>
										<a href="/shipments?shipment=1">All Shipments</a>
									</li>
									<li>
										<a onClick={handleBookedShipmentsClick}>Booked</a>
									</li>
									<li>
										<a onClick={handleScheduledShipmentsClick}>Pick-up Scheduled</a>
									</li>
									<li>
										<a onClick={handleDeliveredShipmentsClick}>Delivered</a>
									</li>
									{/* <li>
										<a onClick={handleNdrShipmentsClick}>NDR Shipments</a>
									</li> */}
									<li>
										<a onClick={handleRtoShipmentsClick}>RTO Shipments</a>
									</li>
                                </ul>
							</li>


							<li className={`treeview ${isActiveintshipment ? 'active' : ''}`}>
								<a href="#!" onClick={toggleActiveintClassshipment}>
									<i class="bi bi-box"></i>
									<span class="menu-text">International Shipments</span>
								</a>
								<ul class="treeview-menu">
									<li>
										<a href="/shipments?shipment=2">All Shipments</a>
									</li>
									<li>
										<a onClick={handleBookedintShipmentsClick}>Booked</a>
									</li>
									<li>
										<a onClick={handleScheduledintShipmentsClick}>Pick-up Scheduled</a>
									</li>
									<li>
										<a onClick={handleDeliveredintShipmentsClick}>Delivered</a>
									</li>
									{/* <li>
										<a onClick={handleNdrShipmentsClick}>NDR Shipments</a>
									</li> */}
									<li>
										<a onClick={handleRtointShipmentsClick}>RTO Shipments</a>
									</li>
                                </ul>
							</li>
							<li>
								<a href="/manifest_list">
									<i class="bi bi-stack"></i>
									<span class="menu-text">Manifest List</span>
								</a>
							</li>
							<li>
								<a href="/pickup_request">
									<i class="bi bi-arrow-up-square"></i>
									<span class="menu-text">Pickup Requests</span>
								</a>
							</li>
							<li>
								<a href="/ndr">
									<i class="bi bi-exclamation-square"></i>
									<span class="menu-text">NDR</span>
								</a>
							</li>
							<li>
								<a href="/warehouse">
									<i class="bi bi-buildings"></i>
									<span class="menu-text">Warehouse</span>
								</a>
							</li>
							<li>
								<a href="/weight_discrepancies_list">
									<i class="bi bi-box2"></i>
									<span class="menu-text">Weight Discrepancy</span>
								</a>
							</li>
                            <li className={`treeview ${isActivetools ? 'active' : ''}`}>
								<a href="#!" onClick={toggleActiveClasstools}>
									<i class="bi bi-wrench"></i>
									<span class="menu-text">Tools</span>
								</a>
								<ul class="treeview-menu">
									<li>
										<a href="/rate_calculator">Rate Calculator</a>
									</li>
									<li>
										<a href="/order_allocation_engine">Order Allocation Engine</a>
									</li>
									<li>
										<a href="/aftership">AfterShip</a>
									</li>
									{/* <li>
										<a href="#">Boxes</a>
									</li> */}
								</ul>
							</li>
                            <li className={`treeview ${isActivebilling ? 'active' : ''}`}>
								<a href="#!" onClick={toggleActiveClassbilling}>
									<i class="bi bi-wallet"></i>
									<span class="menu-text">Billing</span>
								</a>
								<ul class="treeview-menu">
									<li>
										<a href="/billing_shipping_charges">Shipping Charges</a>
									</li>
									<li>
										<a href="/billing_cod_remittance">COD Remittance</a>
									</li>
									<li>
										<a href="/billing_passbook">Account Statement</a>
									</li>
									<li>
										<a href="/billing_deduction">Deduction</a>
									</li>
									<li>
										<a href="billing_recharges">Recharge</a>
									</li>
									{/* <li>
										<a href="billing_refunded.php">Refund</a>
									</li> */}
									<li>
										<a href="/billing_weight_reconciliation">Weight Reconciliation</a>
									</li>
								</ul>
							</li>
              <li className={`treeview ${isActivereport ? 'active' : ''}`}>
              <a href="#!" onClick={toggleActiveClassreport}>
									<i class="bi bi-bar-chart-line"></i>
									<span class="menu-text">Reports</span>
								</a>
								<ul class="treeview-menu">
									<li>
										<a href="/shipment_report">Shipment Reports</a>
									</li>
									<li>
										<a href="/invoices_list">Invoices</a>
									</li>
								</ul>
							</li>
							{/* <li>
								<a href="team.php">
									<i class="bi bi-people"></i>
									<span class="menu-text">Team</span>
								</a>
							</li> */}
              <li className={`treeview ${isActivesupport ? 'active' : ''}`}>
              <a href="#!" onClick={toggleActiveClasssupport}>
									<i class="bi bi-headset"></i>
									<span class="menu-text">Support</span>
								</a>
								<ul class="treeview-menu">
									<li>
										<a href="/tickets">Support Tickets</a>
									</li>
									{/* <li>
										<a href="support-faq.php">Support FAQ's</a>
									</li> */}
								</ul>
							</li>
              <li className={`treeview ${isActivesetting ? 'active' : ''}`}>
              <a href="#!" onClick={toggleActiveClasssetting}>
									<i class="bi bi-gear"></i>
									<span class="menu-text">Settings</span>
								</a>
								<ul class="treeview-menu">
									<li>
										<a href="/channel_list">Channel Integration</a>
									</li>
									<li>
										<a href="/master_label_settings">Lable Settings</a>
									</li>
									{/* <li>
										<a href="#">Developer APIs</a>
									</li> */}
								</ul>
							</li>
						</ul>
					</div>
    </div>
  )
}

export default Sidebar
